"use client";
import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Stack,
  Paper,
  DialogActions,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from "@mui/material";
import { axiosClient, config } from "../../../../services/axiosClient";
import { GridCloseIcon } from "@material-ui/data-grid";
import CustomTextField from "../../../customComponent/CustomTextField";
import { useEffect } from "react";
import imageCompression from 'browser-image-compression';

export default function CarrierFormModal ({order,t,translateStatus}) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  


  const [carrier, setCarrier] = useState({
    orderId: order._id,
    orderNumber: order.orderNumber,
    storeId: order.storeId,
    name:order.status.carrier? order.status.carrier.name:"",
    trackingNumber: order.status.carrier? order.status.carrier.trackingNumber:"",
    trackingUrl: order.status.carrier? order.status.carrier.trackingUrl:"",
    documents: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCarrier((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async(e) => {

    const files = Array.from(e.target.files)
      const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 420,
                    useWebWorker: true
                  }   
       const base64Files = await Promise.all(  
        files.map(async (file) => {
         
                  
        const compressedFile = await imageCompression(file, options);
        const base64 = await convertFileToBase64(compressedFile);
      return {
        name: file.name,
        type: file.type,
        base64,
      };
    })
  );
        console.log(base64Files)
        
    if(base64Files.length>0){
    
            setCarrier((prev) => ({ ...prev, documents: [...prev.documents, ...base64Files] }));

    } 
     console.log(carrier)


  };
 const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result); // result is base64 string
    reader.onerror = reject;
  });
};
  const handleSubmit = async(e) => {
    e.preventDefault();
  
    console.log(carrier)
    axiosClient.post(`${process.env.REACT_APP_SERVER_URL}/orders/carrier/update`, carrier, {
      config,
    });

    console.log("Submitting carrier info:", {
      ...carrier,
      documents: carrier.documents.map((d) => d.name),
    });
    handleClose()
  };
  useEffect(()=>{console.log(carrier)},[carrier])

  return (
   <>
      <Button variant="outlined"  sx={{textTransform:'none'}} onClick={handleOpen}>
        {order.status.carrier ?t("order.carrierupdateinfo") :t("order.carrieraddinfo")}
      </Button>
     
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
         {order.status.carrier ? t("order.carrierupdateinfo") :t("order.carrieraddinfo")}

          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <GridCloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2} mt={1}>
            <CustomTextField
              name="name"
              label={t("order.carriername")}
              value={carrier.name}
              onChange={handleChange}
              fullWidth
            />
            <CustomTextField
              name="trackingNumber"
              label={t("order.carriertrackingnumber")}
              value={carrier.trackingNumber}
              onChange={handleChange}
              fullWidth
            />
            <CustomTextField
              name="trackingUrl"
              label={t("order.carriertrackingurl")}
              value={carrier.trackingUrl}
              onChange={handleChange}
              fullWidth
            />
           

            <Button variant="outlined" component="label">
              {t("order.carrierdocuments")}
              <input
                type="file"
                hidden
                multiple
               /*  accept=".pdf,.doc,.docx,image/*" */
                accept="image/*"
                onChange={handleFileChange}
              />
            </Button>

            {carrier.documents.length > 0 && (
              <Box>
                <Typography variant="subtitle2">Selected Files:</Typography>
                <ul>
                  {carrier.documents.map((file, idx) => (
                    <li key={idx}>{file.name}</li>
                  ))}
                </ul>
              </Box>
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button  sx={{textTransform:'none'}}onClick={handleClose}>{t("dialog.button.cancel")}</Button>

          <Button sx={{ ml: "auto",textTransform:'none'}} onClick={handleSubmit} variant="contained">
            {t("form.submit_button")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
